import { render, staticRenderFns } from "./angebote.vue?vue&type=template&id=0f804cc6&scoped=true&"
import script from "./angebote.vue?vue&type=script&lang=js&"
export * from "./angebote.vue?vue&type=script&lang=js&"
import style0 from "./angebote.vue?vue&type=style&index=0&id=0f804cc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f804cc6",
  null
  
)

export default component.exports